import axios from "axios";

const endpoint = process.env.REACT_APP_API_URL;

export const FETCH_VEHICLE_TRIPS_BEGIN = "FETCH_VEHICLE_TRIPS_BEGIN";
export const FETCH_VEHICLE_TRIPS_SUCCESS = "FETCH_VEHICLE_TRIPS_SUCCESS";
export const FETCH_VEHICLE_TRIPS_FAILURE = "FETCH_VEHICLE_TRIPS_FAILURE";

export const fetchVehicleTripsBegin = () => ({
  type: FETCH_VEHICLE_TRIPS_BEGIN,
});

export const fetchVehicleTripsSuccess = (vehicleTrips) => ({
  type: FETCH_VEHICLE_TRIPS_SUCCESS,
  payload: vehicleTrips,
});

export const fetchVehicleTripsFailure = (error) => ({
  type: FETCH_VEHICLE_TRIPS_FAILURE,
  payload: { error },
});

export async function getVehicleTrips(id, tripDate) {
  const {start, end} = tripDate;
  return async (dispatch) => {
    dispatch(fetchVehicleTripsBegin());
    try {
      const { data } = await axios.get(`${endpoint}/vehicles/${id}/trips?start=${start}&end=${end}`);
      dispatch(fetchVehicleTripsSuccess(data));
    } catch (err) {
      dispatch(fetchVehicleTripsFailure(err));
    }
  };
}